<template>
  <div class="index-box">
    <div class="infdex-top">
      <div
        :class="index == 1 ? 'index-top-left' : 'index-top-right'"
        @click="schoolClick(1)"
      >
        <div>校友企业</div>
        <div class="index-top-left-line"></div>
      </div>
      <div
        :class="index == 2 ? 'index-top-left' : 'index-top-right'"
        @click="schoolClick(2)"
      >
        <div>科技成果</div>
        <div class="index-top-left-line"></div>
      </div>
    </div>

    <div style="margin-top: 55px">
      <!-- 校友企业 -->
      <div
        class="imageListCardVideo"
        v-for="(item, index) in wholeList.data"
        :key="index"
      >
        <div class="card-list__itemone">
          <div class="headDiagram">
            <img :src="item.logoPath" @click="getScoolDetail(item)" />
            <span @click="getScoolDetail(item)">{{ item.companyName }}</span>
            <img
              v-if="item.subdisplay == 0"
              @click="gotoWhole(item)"
              :src="zhankai"
              alt=""
            />
            <img
              v-if="item.subdisplay == 1"
              @click="gotoPutItAway(item)"
              :src="shouqi"
              alt=""
            />
          </div>
          <img
            class="qiyeImg"
            :src="item.imgPath"
            @click="getScoolDetail(item)"
          />

          <!-- 子模块--科技成果 -->
          <div v-if="item.subdisplay == 1">
            <div v-for="(zi, index) in wholeList.dataSubdisplay" :key="index">
              <div
                class="submodule-box"
                v-if="
                  zi.id === item.id &&
                  zi.achievementImg != '' &&
                  zi.achName != '' &&
                  zi.achievementImg != null &&
                  zi.achName != null
                "
                @click="getAchievementDetailSi(zi)"
              >
                <img :src="zi.achievementImg" />
                <div>{{ zi.achName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 科技成果 -->
      <div
        class="imageListCard"
        v-for="item in achievement"
        :key="item.index"
        @click="getAchievementDetail(item)"
      >
        <div
          class="card-list__itemone"
          :style="{ backgroundImage: `url(${item.sAchievementImg})` }"
        ></div>
        <div class="school-box-txt">
          <div>{{ item.sName }}</div>
          <div>{{ item.sDescription }}</div>
          <div>
            <img :src="btnGuankan" />
            <div>{{ item.sEyes }}</div>
          </div>
        </div>
      </div>
    </div>

    <img
      class="chuangjian"
      v-show="index == 1"
      :src="btnChuangjian"
      @click="nvliangDialog"
    />

    <van-dialog
      v-model="isNewNvliangDialog"
      :showConfirmButton="false"
      closeOnClickOverlay
      closeOnPopstate
      width="24.76rem"
    >
      <div class="active-list__new-activity-content">
        <img
          class="active-list__new-activity-content-bg"
          :src="BgNewActivityTop"
        />
        <div class="active-list__new-activity-content-main">
          <div class="active-list__new-activity-content-title">
            欢迎校友企业加入！
          </div>
          <div class="active-list__new-activity-content-describe">
            <div>请向校友办公室申请</div>
            <div style="margin-top: 0.5rem">并提交企业信息</div>
            <div style="margin-top: 2rem">校友会办公室电话：135-9611-8838</div>
          </div>
          <div
            class="active-list__new-activity-content-contact"
            @click="closeDialog()"
          >
            知道了
          </div>
        </div>
        <img
          class="active-list__new-activity-content-bg"
          :src="BgNewActivityBottom"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import btnGuankan from "@/assets/image/btn_guankan_nor.png";
import btnChuangjian from "@/assets/image/btn_chuangjian_nor.png";
import BgNewActivityTop from "@/assets/image/active/btn_shang_nor.png";
import BgNewActivityBottom from "@/assets/image/active/btn_xia_nor.png";
import defaultAvatar from "@/assets/image/defaultAvatar.png";
import zhankai from "@/assets/image/btn_zhankai_nor.png";
import shouqi from "@/assets/image/btn_shouqii_nor.png";
export default {
  data() {
    return {
      btnGuankan,
      btnChuangjian,
      defaultAvatar,
      BgNewActivityTop,
      BgNewActivityBottom,
      zhankai,
      shouqi,
      schoolList: [],
      achievement: [],
      index: 1,
      isNewNvliangDialog: false,
      wholeList: {
        data: [],
        dataSubdisplay: [],
      },
    };
  },
  created() {
    this.getSchoolList();
  },
  methods: {
    // 校友企业获取
    async getSchoolList() {
      const result = await this.$http.get("/schoolEnterprise/getAllEnterprise");
      console.log("校友企业获取", result.data);

      this.schoolList = result.data.filter((item, index) => {
        return index === result.data.findIndex((r) => r.id === item.id);
      });

      this.schoolList.forEach((item) => {
        item["subdisplay"] = 0;
      });

      this.wholeList.data = this.schoolList;
      this.wholeList.dataSubdisplay = result.data;
      console.log("111", this.wholeList);
    },
    // 科技成果
    async getAchievement() {
      const result = await this.$http.get(
        "/achievementTransform/getAllAchievement"
      );
      console.log("获取科技成果", result.data);
      this.achievement = result.data;
    },
    schoolClick(index) {
      this.index = index;
      if (index == 1) {
        this.getSchoolList();
        this.achievement = [];
      } else {
        this.getAchievement();
        this.wholeList.data = [];
        this.wholeList.dataSubdisplay = [];
        // this.schoolList = [];
      }
    },
    // 跳转校友企业详情
    async getScoolDetail(item) {
      return this.$router.push({
        path: "/schoolDetaile",
        query: { id: item.id },
      });
    },

    // 跳转科技成果详情--列表
    async getAchievementDetail(item) {
      console.log("跳转科技成功详情", item);
      return this.$router.push({
        path: "/achievement",
        query: { id: item.sId },
      });
    },
    // 跳转科技成果详情
    async getAchievementDetailSi(zi) {
      return this.$router.push({
        path: "/achievement",
        query: { id: zi.achId },
      });
    },

    nvliangDialog() {
      this.isNewNvliangDialog = true;
    },
    closeDialog() {
      this.isNewNvliangDialog = false;
    },

    // 展开
    async gotoWhole(item) {
      const list = this.wholeList.data;
      const result = await this.$http.get("/schoolEnterprise/getAllEnterprise");
      this.schoolList = result.data.filter((item, index) => {
        return index === result.data.findIndex((r) => r.id === item.id);
      });
      this.schoolList.forEach((item) => {
        item["subdisplay"] = 0;
      });

      list.forEach((item, index) => {
        if (this.schoolList[index].subdisplay != item.subdisplay) {
          this.schoolList[index].subdisplay = item.subdisplay;
        }
      });
      this.wholeList.data = this.schoolList;
      this.wholeList.dataSubdisplay = result.data;
      this.wholeList.data.forEach((v) => {
        console.log("展开了", v);
        if (v.id === item.id) {
          v.subdisplay = 1;
        }
      });
    },
    // 收起
    async gotoPutItAway(item) {
      const list = this.wholeList.data;
      const result = await this.$http.get("/schoolEnterprise/getAllEnterprise");
      this.schoolList = result.data.filter((item, index) => {
        return index === result.data.findIndex((r) => r.id === item.id);
      });
      this.schoolList.forEach((item) => {
        item["subdisplay"] = 0;
      });

      list.forEach((item, index) => {
        if (this.schoolList[index].subdisplay != item.subdisplay) {
          this.schoolList[index].subdisplay = item.subdisplay;
        }
      });

      this.wholeList.data = this.schoolList;
      this.wholeList.dataSubdisplay = result.data;
      this.wholeList.data.forEach((v) => {
        if (v.id === item.id) {
          v.subdisplay = 0;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  .infdex-top {
    position: fixed;
    top: 45px;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .index-top-left {
      width: 50vw;
      height: 50px;
      background: #edf6f3;
      color: #067371;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;
      .index-top-left-line {
        width: 30px;
        height: 3px;
        background: #067371;
        margin-top: 3px;
      }
    }
    .index-top-right {
      width: 50vw;
      height: 50px;
      background: #edf6f3;
      color: #9e9e9e;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;
      .index-top-right-line {
        width: 30px;
        height: 3px;
        background: #9e9e9e;
        opacity: 0;
        margin-top: 3px;
      }
    }
  }

  .imageListCardVideo {
    display: flex;
    width: 90vw;
    border-radius: 0.5rem;
    min-height: 16rem;
    margin-left: 5vw;
    margin-top: 10px;
    border: 1px solid #e6e6e6;
    // background: #bcf0f0;
    .card-list__itemone {
      flex: 1;
      border-radius: 10px;
      image-rendering: -webkit-optimize-contrast;

      .headDiagram {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 50px;
        line-height: 50px;
        background: #fff;
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
        // background: #cbcbcb;
      }
      .headDiagram :nth-child(1) {
        width: 40px;
        height: 40px;
        border: 1px solid #f5f5f5;
        border-radius: 5px;
        object-fit: cover;
        // image-rendering: -webkit-optimize-contrast;
        margin: 2.5px 2.5px 2.5px 10px;
      }
      .headDiagram :nth-child(2) {
        color: #000;
        // font-weight: 600;
        padding-left: 10px;
        font-size: 0.9rem;
      }
      .headDiagram :nth-child(3) {
        color: #000;
        font-weight: 500;
        font-size: 0.95rem;
        position: absolute;
        right: 7vw;
      }

      .qiyeImg {
        position: relative;
        width: 100%;
        height: 200px;
        // height: calc(100% - 50px);
        border-bottom-left-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
        image-rendering: -webkit-optimize-contrast;
        margin-bottom: 10px;
      }

      .submodule-box {
        // position: relative;
        width: 85vw;
        margin-left: 2.5vw;
        background: #f8f8f8;
        border: 1px solid #e6e6e6;
        margin-bottom: 5px;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
      }
      .submodule-box :nth-child(1) {
        position: relative;
        width: 130px;
        height: 80px;
        border-radius: 0.5rem;
        object-fit: cover;
        padding: 5px;
      }
      .submodule-box :nth-child(2) {
        color: #067371;
        padding: 5px 10px 5px 10px;
        font-size: 0.9rem;
        font-weight: 600;
      }
    }
  }

  .imageListCard {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 90vw;
    border-radius: 0.5rem;
    height: 8rem;
    margin-left: 5vw;
    margin-top: 10px;
    border: 1px solid #e6e6e6;
    image-rendering: -webkit-optimize-contrast;
    .card-list__itemone {
      // flex: 1;
      width: 42%;
      height: 6rem;
      border: 1px solid #f5f5f5;
      margin: 10px;
      border-radius: 10px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
    .school-box-txt {
      width: 55%;
      // border: 1px solid #000;
      margin: 5px 5px 10px 0px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .school-box-txt :nth-child(1) {
      margin-top: 0px;
      color: #000;
      font-size: 0.9rem;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .school-box-txt :nth-child(2) {
      margin-top: 2px;
      color: #6f6f6f;
      font-size: 0.8rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .school-box-txt :nth-child(3) {
      margin-top: 25px;
      color: #6f6f6f;
      font-size: 0.8rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex-direction: row;
      display: flex;
      align-items: center;
    }

    .school-box-txt :nth-child(3) > img:first-child {
      width: 13px;
      height: 10px;
      margin-right: 5px;
    }
  }
  .chuangjian {
    position: fixed;
    top: 28rem;
    right: 0;
  }

  .active-list__new-activity-content-main {
    padding: 0rem 1.6rem 2.88rem 1.6rem;
  }

  .active-list__new-activity-content-title {
    font-size: 1.45rem;
    color: #00706e;
    line-height: 1rem;
    text-align: center;
  }

  .active-list__new-activity-content-bg {
    display: block;
    width: 100%;
  }

  .active-list__new-activity-content-describe {
    text-align: center;
    margin-top: 1.5rem;
  }

  .active-list__new-activity-content-contact {
    margin-top: 70px;
    width: 50%;
    line-height: 40px;
    text-align: center;
    color: #fff;
    border-radius: 20px;
    margin-left: 25%;
    background: #00706e;
  }

  .active-list__item-info-detail-progress {
    margin-top: 0.88rem;
    display: flex;
    align-items: center;
  }

  .active-list__item-info-detail-progress-bar {
    flex: 1 1 auto;
    // height: 0.76rem;
    background: #f5f5f5;
    border-radius: 0.38rem;
    border: 1px solid #cbcbcb;
    padding: 2px;
    box-sizing: border-box;
  }

  .active-list__item-info-detail-progress-bar-inner {
    background: #00706e;
    border-radius: 0.27rem;
    height: 0.53rem;
  }

  .active-list__item-info-detail-progress-text {
    flex: 0 0 auto;
    margin-left: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/SchoolRrunEnterprise.vue